export default __webpack_public_path__ + "static/media/hot.3bb54a05.png";